import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { createGetSelection } from '../app/selectors';
import { selectionSlice } from '../features/selection/selectionSlice';
import { actionBinder } from '../utils/actionBinder';

export const useSelection = (
    instanceId: string,
): [Record<string, boolean>, (...args: any[]) => void, (...args: any[]) => void, (...args: any[]) => void] => {
    const dispatch = useDispatch();
    const [getSelectionSelector, select, unselect, set] = useMemo(
        () => [
            createGetSelection(instanceId),
            ...[selectionSlice.actions.select, selectionSlice.actions.unselect, selectionSlice.actions.set].map(
                (action: any) =>
                    (...args: any[]) => {
                        const actionCreator = actionBinder(action, instanceId);

                        // @ts-ignore
                        return dispatch(actionCreator(...args));
                    },
            ),
        ],
        [dispatch, instanceId],
    );
    const selection = useSelector(getSelectionSelector);

    return [selection, select, unselect, set];
};
